import React from "react";
import { IMAGES, PAPERBACK_URL, KINDLE_URL } from "../site-data";
import { ArrowRight, BookMarked } from "lucide-react";

export default function AboutBook() {
  return (
    <section
      id="book"
      data-testid="about-book-section"
      className="relative py-24 lg:py-36 paper-bg"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-6">
          <div className="grid grid-cols-2 gap-6">
            <img
              src={IMAGES.bookFront}
              alt="Book front cover"
              data-testid="about-book-front"
              className="w-full book-shadow border border-[#e5dcd0]"
            />
            <img
              src={IMAGES.bookBack}
              alt="Book back cover"
              data-testid="about-book-back"
              className="w-full book-shadow border border-[#e5dcd0] mt-10"
            />
          </div>
        </div>

        <div className="lg:col-span-6">
          <p className="eyebrow mb-5">The Book</p>
          <h2 className="font-serif text-4xl lg:text-5xl leading-[1.05] tracking-tight text-[#1c1a1a]"
              data-testid="about-book-title">
            A Bouquet of <span className="italic text-[#8b2e3e]">8 Roses</span>
          </h2>
          <p className="mt-4 font-serif italic text-xl text-[#4a4646]">
            Stories that touch every heart.
          </p>

          <div className="mt-8 space-y-5 text-[#4a4646] leading-relaxed text-lg max-w-xl">
            <p>
              When an orphaned boy stumbles upon a lost wallet, when two friends confront
              prejudice from opposite sides, when a young girl chooses compassion over
              convenience to save an injured puppy, and when underdogs dare to compete
              against the odds — something quietly powerful unfolds.
            </p>
            <p>
              These eight beautifully woven stories explore moments where small choices
              carry lasting meaning. They remind us that honesty can open unexpected doors,
              friendship can bridge differences, love does not recognise boundaries, and
              kindness has a way of travelling further than we imagine.
            </p>
          </div>

          <blockquote className="mt-10 border-l-2 border-[#8b2e3e] pl-6 max-w-lg">
            <p className="font-serif italic text-2xl text-[#1c1a1a] leading-snug">
              "Tender, hopeful, and deeply human — these stories linger long after the last page."
            </p>
          </blockquote>

          <a
            href={PAPERBACK_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="about-book-buy-btn"
            className="btn-rose mt-10 mr-3 inline-flex items-center gap-2 bg-[#8b2e3e] hover:bg-[#6d2230] text-white px-7 py-4 text-sm tracking-[0.15em] uppercase transition-colors"
          >
            Paperback · Amazon <ArrowRight size={16} />
          </a>
          <a
            href={KINDLE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="about-book-kindle-btn"
            className="mt-10 inline-flex items-center gap-2 border border-[#1c1a1a] hover:bg-[#1c1a1a] hover:text-white text-[#1c1a1a] px-7 py-4 text-sm tracking-[0.15em] uppercase transition-colors"
          >
            <BookMarked size={16} /> Read on Kindle
          </a>
        </div>
      </div>
    </section>
  );
}
